import { loanTypeDescription } from '@apply/constants';
import DataGrid, { Column, Pager, Paging } from 'devextreme-react/data-grid';
import { formatCurrencyOptionalTwoDigit } from '../../../common/components/lendingLimitAccordionPanel/components/common/formatters/formatCurrencyOptionalTwoDigit';
import { ILoanHistorySummaryTableRow } from '../../../common/components/lendingLimitAccordionPanel/components/common/constants/tables/interfaces/ILoanHistorySummaryTableRow';

interface LoanSummaryTableProps {
    loans: ILoanHistorySummaryTableRow[] | undefined;
}
export const LoanSummaryTable: React.FC<LoanSummaryTableProps> = ({ loans }) => {
    return (
        <>
            <DataGrid
                dataSource={loans}
                keyExpr='id'
                showBorders={true}
                showRowLines={true}
                rowAlternationEnabled={true}
                remoteOperations={false}
                allowColumnReordering={true}
                allowColumnResizing={true}
                noDataText='No Loan History Available'
            >
                <Paging defaultPageSize={5} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[5, 10, 20]}
                    showNavigationButtons={true}
                    showInfo={true}
                    infoText='Page {0} of {1}'
                />
                <Column
                    dataField='bfiNumber'
                    caption='BFI #'
                    alignment={'left'}
                    width={100}
                />
                <Column
                    dataField='loanNumber'
                    caption='Loan #'
                    width={100}
                    alignment={'left'}
                />
                <Column
                    dataField='loanType'
                    caption='Loan Type'
                    width={140}
                    alignment={'left'}
                    cellRender={(cellData: any) => loanTypeDescription[cellData.data.loanType]}
                />
                <Column
                    dataField='committedAmount'
                    caption='Committed Amount'
                    width={160}
                    alignment={'right'}
                    cellRender={(e) => formatCurrencyOptionalTwoDigit(e.value)}
                />
                <Column
                    dataField='amountRepaid'
                    caption='Amount Repaid'
                    alignment={'right'}
                    width={160}
                    cellRender={(e) => formatCurrencyOptionalTwoDigit(e.value)}
                />
                <Column
                    dataField='repaymentDate'
                    caption='Repayment Date'
                    dataType='date'
                    alignment={'center'}
                    width={160}
                />
                <Column
                    dataField='appraisedValue'
                    caption='Appraised Value'
                    alignment={'right'}
                    cellRender={(e) => formatCurrencyOptionalTwoDigit(e.value)}
                />
            </DataGrid>
        </>
    );
};
